import { Injectable, ErrorHandler } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AppInsightsService } from './app-insights.service';


@Injectable()
export class ErrorHandlerService extends ErrorHandler {

    constructor(private appInsightsService: AppInsightsService) {
        super();
    }

    handleError(error: Error) {
        if (error && error.name && environment.production) {
            error.name = 'Client side error.'
            this.appInsightsService.logException(error);
        }
    }
}